import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { DecimalNumberDirective } from "./directives/decimal-number.directive";
import { RutFormaterDirective } from "./directives/rut-format.directive";
import { HasRolesDirective } from "./directives/has-roles.directive";
import { RutFormatPipe } from "./pipes/rut-format.pipe";
import { AlertComponent } from "./components/alert/alert.component";
import { ToastComponent } from "./components/toast/toast.component";
import { MatIconModule } from "@angular/material/icon";
import { CapitalizePipe } from "./pipes/capitalize.pipe";
import { JavaDatePipe } from "./pipes/java-date.pipe";
import { MaterialModule } from "src/app/app.material.module";
import { PdfPreviewModalComponent } from "./pdf-preview-modal/pdf-preview-modal.component";
import { ServiceLineMultiselectComponent } from "./components/service-line-multiselect/service-line-multiselect.component";
import { PeriodoSelectComponent } from "./components/periodo-select/periodo-select.component";

@NgModule({
  declarations: [
    DecimalNumberDirective,
    RutFormaterDirective,
    RutFormatPipe,
    AlertComponent,
    ToastComponent,
    CapitalizePipe,
    JavaDatePipe,
    PdfPreviewModalComponent,
    ServiceLineMultiselectComponent,
    PeriodoSelectComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MaterialModule,
    HasRolesDirective
  ],
  exports: [
    AlertComponent,
    ToastComponent,
    DecimalNumberDirective,
    RutFormaterDirective,
    HasRolesDirective,
    RutFormatPipe,
    CapitalizePipe,
    JavaDatePipe,
    ServiceLineMultiselectComponent,
    PeriodoSelectComponent,
  ]
})
export class SharedModule {}
